"use client";

import { Suspense, useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import LoadingSpinner from "@/components/LoadingSpinner";
import { useExperiment } from "@/hooks/useExperiment";
import { LANDING_DESTINATION_V1_EXPERIMENT_ID } from "@/libs/experiments";
import { isLandingCreatePfp } from "@/libs/landingHandoff";

export const dynamic = "force-dynamic";

function HomeRedirect() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { variant } = useExperiment(LANDING_DESTINATION_V1_EXPERIMENT_ID);

  useEffect(() => {
    if (
      isLandingCreatePfp({
        from: searchParams.get("from"),
        intent: searchParams.get("intent"),
      })
    ) {
      const dest = new URLSearchParams(searchParams.toString());
      dest.set("from", "landing");
      dest.set("intent", "create_pfp");
      router.replace(`/dashboard?${dest.toString()}`);
      return;
    }
    if (variant === "ai_avatars") {
      router.replace("/editor-v2/ai-avatars");
    } else {
      router.replace("/dashboard");
    }
  }, [router, variant, searchParams]);

  return <LoadingSpinner fullScreen text="Loading..." />;
}

export default function HomePage() {
  return (
    <Suspense fallback={<LoadingSpinner fullScreen text="Loading..." />}>
      <HomeRedirect />
    </Suspense>
  );
}
